import { render, staticRenderFns } from "./NovoNegocio.vue?vue&type=template&id=51fab689"
import script from "./NovoNegocio.vue?vue&type=script&lang=js"
export * from "./NovoNegocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports